module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3z0sYA0t84iwooEo2CCGuk-7bf203e326597a185a2db28999ba020e.jpg";